import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';

import theme from './theme';
import MarkdownText from './MarkdownText';

/**
 * Emotion style classes
 */
const headerColor = css`
  background-color: ${theme.color.primary} !important;
  border-bottom: 0.25em solid ${theme.color.highlight} !important;
`;

/**
 * Components
 */
const PopupCard = ({ title, visible, closeCard, children }) => {
  if (visible) {
    return (
      <div className="modal is-active">
        <div className="modal-background" onClick={closeCard} />
        <div className="modal-card">
          <header className={`modal-card-head ${headerColor}`}>
            <p className="modal-card-title has-text-white is-capitalized">
              {title}
            </p>
            <button className="delete" aria-label="close" onClick={closeCard} />
          </header>
          <section className="modal-card-body">
            <MarkdownText>{children}</MarkdownText>
          </section>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

PopupCard.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]).isRequired,
  closeCard: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  visible: PropTypes.bool,
};

PopupCard.defaultProps = {
  visible: true,
};

export default PopupCard;
